// @ts-strict-ignore
import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";

import { AviaryProvider } from "@aviary/utils";
import { LazyExperimentTester } from "@shared/components/ExperimentTester/LazyExperimentTester/LazyExperimentTester";
import { LoadingProvider } from "@shared/components/LoadingProvider/LoadingProvider";
import { Router } from "@shared/components/Router/Router";
import { FlippersProvider } from "@shared/context/FlippersContext";
import {
  GlobalContextUserRole,
  GlobalContextProvider as SharedGlobalContextProvider,
} from "@shared/context/GlobalConfig";
import type { ExperimentContextData } from "@shared/context/experiment/experiment.store";
import { createExperimentVar } from "@shared/context/experiment/experiment.store";
import type { Flipper } from "@shared/types/flipper";
import { ApolloClientProvider } from "@unauthenticated/oauth/components/Providers/ApolloClientProvider/ApolloClientProvider";
import { GlobalContextProvider } from "@unauthenticated/shared/context/GlobalConfig/GlobalConfig";

import { i18n } from "../../locales/i18n";

interface Props {
  currentCountry: string;
  flippers?: Flipper[];
  e2e: boolean;
  children: ReactNode;
  experimentData: ExperimentContextData;
}

const Providers = ({ children, currentCountry, flippers, e2e, experimentData }: Props) => {
  createExperimentVar(experimentData);

  return (
    <FlippersProvider flippers={flippers}>
      <Router>
        <I18nextProvider i18n={i18n}>
          <LoadingProvider>
            <ApolloClientProvider>
              <SharedGlobalContextProvider
                country={currentCountry}
                role={GlobalContextUserRole.UNAUTHENTICATED}
                e2e={e2e}
              >
                <GlobalContextProvider treatmentPlanTerm={null}>
                  <AviaryProvider controlledTheme="light">
                    <>{children}</>
                    <LazyExperimentTester />
                  </AviaryProvider>
                </GlobalContextProvider>
              </SharedGlobalContextProvider>
            </ApolloClientProvider>
          </LoadingProvider>
        </I18nextProvider>
      </Router>
    </FlippersProvider>
  );
};

export { Providers };
